import { MASKED_GLOBAL_TOOLKIT_ID } from './api'
import { User } from '../auth/types'
import { PlanInfo } from '../organizations/types'

export const checkRAGAccess = (
  knowledgeBaseId: string | undefined,
  planInfo: PlanInfo | undefined,
  user: User,
) => {
  if (!knowledgeBaseId) return false

  if (knowledgeBaseId === MASKED_GLOBAL_TOOLKIT_ID && user.role === 'admin') {
    return true
  }

  if (!planInfo) return false

  return Boolean(planInfo?.hasAccessToRAG)
}
